export class CourseGroupModel {
    constructor(ProgramId, BoardId, CourseGroups, SubscriptionType) {
      this.ProgramId = ProgramId;
      this.CourseGroups = CourseGroups
      this.BoardId = BoardId
      this.SubscriptionType = SubscriptionType
    }
  }